import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import useApi from "../../../../utils/api";
import { getErrorMessage } from "../../../../utils/helpers/errors";

export const useHistoryApi = () => {
    const { t } = useTranslation();
    const [data, setData] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [loading, setLoading] = useState(false);
    const { authGet } = useApi();

    const getHistory = useCallback(
        async (params, controller) => {
            setLoading(true);
            try {
                const response = await authGet("/log/v2/settings", {
                    params,
                    signal: controller?.signal,
                });
                if (response) {
                    setData(response?.result);
                    setTotalItems(response?.totalItems);
                }
            } catch (err) {
                getErrorMessage(err, t);
            } finally {
                setLoading(false);
            }
        },
        [authGet, t]
    );

    return {
        data,
        loading,
        totalItems,
        getHistory,
    };
};
